import React, { useEffect, useState } from "react";
import { Admin_Region_List, Admin_Region_Name } from "../../../constants";
import axios from "axios";
import { Breadcrumbs, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import TableComponent from "./components/TableComponent";
import AddNewRegionModalComponent from "./components/AddNewRegionModal";

const RegionManagementComponent = () => {
  const [regionList, setRegionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addNewRegionModalOpen, setAddNewRegionModalOpen] = useState(false);

  const getAllRegionData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Admin_Region_List}`);
      const region = response.data.data || [];
      setRegionList(region);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching region data:", error);
      return null; // Return null or empty array on error
    }
  };

  useEffect(() => {
    getAllRegionData();
  }, []);

  const handleBack = () => {};

  const columns = [
    { headerName: "Region ID", field: "RegionId" },
    { headerName: "Region Name", field: "RegionName" },
    
  ];

  const fetchRegionData = async () => {
    try {
      const response = await axios.get(`${Admin_Region_List}`);
      const region = response.data.data || [];

      return region; // RETURN data for use in handleExport
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      return null; // Return null or empty array on error
    }
  };

  const handleExport = async () => {
    const data = await fetchRegionData();
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.field];
         
          return value || "";
        })
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Region_Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `region_data_${dayjs().format("YYYYMMDD")}.xlsx`);
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Region Management
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Region Management</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddNewRegionModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New Region
            </Button>

            <Button
                onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <TableComponent
          regionList={regionList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={getAllRegionData}
        />

        <AddNewRegionModalComponent
          open={addNewRegionModalOpen}
          onClose={() => setAddNewRegionModalOpen(false)}
          onRefresh={getAllRegionData}
        />
      </div>
    </>
  );
};

export default RegionManagementComponent;
